export function getPropertyValueFromProperties(properties, propertyName) {
  if (!properties) {
    return undefined;
  }
  for (const property of properties) {
    if (property.name === propertyName) {
      return property.value;
    }
  }
  return undefined;
}
export const getPrimaryDisplayLabelFromOptions = primaryDisplayProperty => {
  if (!primaryDisplayProperty) {
    return null;
  }
  for (const option of ((_primaryDisplayProper = primaryDisplayProperty.definition) === null || _primaryDisplayProper === void 0 ? void 0 : _primaryDisplayProper.options) || []) {
    var _primaryDisplayProper;
    if (option.value === primaryDisplayProperty.value) {
      return option.label;
    }
  }
  return primaryDisplayProperty.value;
};
export const getPropertyDefinition = (propertyName, propertyDefinitions) => {
  if (!propertyDefinitions) {
    return undefined;
  }
  if ('objectTypeDefinition' in propertyDefinitions) {
    var _propertyDefinitions$;
    return ((_propertyDefinitions$ = propertyDefinitions.objectTypeDefinition) === null || _propertyDefinitions$ === void 0 || (_propertyDefinitions$ = _propertyDefinitions$.propertyDefinitions) === null || _propertyDefinitions$ === void 0 ? void 0 : _propertyDefinitions$.find(definition => definition.name === propertyName)) || undefined;
  }
  for (const definition of propertyDefinitions) {
    if (definition.property.name === propertyName) {
      return definition.property;
    }
  }
  return undefined;
};